import { observer } from 'mobx-react';
import { FC, useCallback } from 'react';
import { customerProfileEditStore } from '../../store';
import { TBooleanInNumber } from 'src/types/main';
import Text, { TEXT } from 'src/view/components/Text/Text';
import Switcher from '~/view/components/Controls/Switcher/Switcer';

const CustomerProfileEditStatusSwitcher: FC = observer((): JSX.Element => {
  const { customer, editCustomerHandler } = customerProfileEditStore;

  const onStatusEdit = useCallback((status: TBooleanInNumber) => {
    editCustomerHandler({ status });
  }, []);

  return (
    <div className="d-flex flex-row align-items-center mb-4">
      <Switcher status={customer?.status || 0} onChange={onStatusEdit} />
      <Text type={TEXT.SWITCHER_LABEL} text="status" />
    </div>
  );
});

export default CustomerProfileEditStatusSwitcher;
